import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'src/components/ui/tooltip';
import { clsx } from 'clsx';
import React from 'react';

export const UploadErrorToolTip = ({
  trigger = null,
  text = '',
  side = 'top' as 'top' | 'right' | 'bottom' | 'left',
  contentClassName = '',
}: {
  trigger?: React.ReactNode;
  text?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  contentClassName?: string;
}) => {
  const [open, setOpen] = React.useState(false);

  return (
    <div>
      <TooltipProvider>
        <Tooltip open={open} onOpenChange={setOpen} delayDuration={0}>
          <TooltipTrigger asChild>
            {trigger || (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="13"
                viewBox="0 0 12 13"
                fill="none"
                onClick={() => {
                  setOpen(true);
                }}
              >
                <path
                  opacity="0.3"
                  d="M5.4 9.5H6.6V5.9H5.4V9.5ZM6 4.7C6.17 4.7 6.3126 4.6424 6.4278 4.5272C6.543 4.412 6.6004 4.2696 6.6 4.1C6.5996 3.9304 6.542 3.788 6.4272 3.6728C6.3124 3.5576 6.17 3.5 6 3.5C5.83 3.5 5.6876 3.5576 5.5728 3.6728C5.458 3.788 5.4004 3.9304 5.4 4.1C5.3996 4.2696 5.4572 4.4122 5.5728 4.5278C5.6884 4.6434 5.8308 4.7008 6 4.7ZM6 12.5C5.17 12.5 4.39 12.3424 3.66 12.0272C2.93 11.712 2.295 11.2846 1.755 10.745C1.215 10.2054 0.7876 9.5704 0.4728 8.84C0.158001 8.1096 0.000400759 7.3296 7.59493e-07 6.5C-0.00039924 5.6704 0.157201 4.8904 0.4728 4.16C0.7884 3.4296 1.2158 2.7946 1.755 2.255C2.2942 1.7154 2.9292 1.288 3.66 0.9728C4.3908 0.6576 5.1708 0.5 6 0.5C6.8292 0.5 7.6092 0.6576 8.33999 0.9728C9.07079 1.288 9.7058 1.7154 10.245 2.255C10.7842 2.7946 11.2118 3.4296 11.5278 4.16C11.8438 4.8904 12.0012 5.6704 12 6.5C11.9988 7.3296 11.8412 8.1096 11.5272 8.84C11.2132 9.5704 10.7858 10.2054 10.245 10.745C9.7042 11.2846 9.06919 11.7122 8.33999 12.0278C7.6108 12.3434 6.8308 12.5008 6 12.5ZM6 11.3C7.34 11.3 8.47499 10.835 9.40499 9.905C10.335 8.975 10.8 7.84 10.8 6.5C10.8 5.16 10.335 4.025 9.40499 3.095C8.47499 2.165 7.34 1.7 6 1.7C4.66 1.7 3.525 2.165 2.595 3.095C1.665 4.025 1.2 5.16 1.2 6.5C1.2 7.84 1.665 8.975 2.595 9.905C3.525 10.835 4.66 11.3 6 11.3Z"
                  fill="#05050D"
                />
              </svg>
            )}
          </TooltipTrigger>
          <TooltipContent
            side={side}
            className={clsx(
              'max-w-2xl text-xs text-ebony_opacity_80 select-none',
              contentClassName,
            )}
          >
            <span>{text}</span>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
